var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcActionsView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-actions-view",
    transform: "translate(-0.476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 24,
    height: 24,
    transform: "translate(0.476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    transform: "translate(0.855 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_108",
    "data-name": "Vrstva 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M22.85,11.48h0v-.06l-.14-.21c-.13-.18-.31-.43-.54-.73a16.42,16.42,0,0,0-2.07-2.2A12.22,12.22,0,0,0,12,5,12.22,12.22,0,0,0,4,8.25a16.42,16.42,0,0,0-2.07,2.2c-.23.3-.41.55-.54.73l-.14.21v.06h0L.83,12l.32.54h0v.06l.14.21c.13.18.31.43.54.73A16.42,16.42,0,0,0,4,15.75,12.22,12.22,0,0,0,12,19a12.22,12.22,0,0,0,8.05-3.25,16.42,16.42,0,0,0,2.07-2.2c.23-.3.41-.55.54-.73l.14-.21v-.06h0l.32-.52Zm-2.31.84a14.36,14.36,0,0,1-1.81,1.93A10.2,10.2,0,0,1,12,17a10.2,10.2,0,0,1-6.73-2.75,15.23,15.23,0,0,1-1.82-1.93L3.21,12l.24-.32A15.23,15.23,0,0,1,5.27,9.75,10.2,10.2,0,0,1,12,7a10.2,10.2,0,0,1,6.73,2.75,14.36,14.36,0,0,1,1.81,1.93c.1.12.18.22.25.32S20.64,12.2,20.54,12.32Z",
    transform: "translate(-0.83 -5)",
    fill: "#32312f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8.17 4)",
    fill: "#32312f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionsView);
export default __webpack_public_path__ + "static/media/ic-actions-view.9c28100db34ae3a0355e0141d30b4f7f.svg";
export { ForwardRef as ReactComponent };